module.exports = __webpack_public_path__ + "f37896bf6dfc9ae087a7b992db0621f0.pdf";